const LpData = {
    ar: {
      document_type: "CUIT",
      IsoCode3: "ARG",
      currency: "ARS"
    },
    bo: {
      document_type: "CUIT",
      IsoCode3: "BOL",
      currency: "BOB"
    },
    br: {
      document_type: "CPF/CNPJ",
      IsoCode3: "BRA",
      currency: "BRL"
    },
    cl: {
      document_type: "tu RUT",
      IsoCode3: "CHL",
      currency: "CLP"
    },
    co: {
      document_type: "CUIT",
      IsoCode3: "COL",
      currency: "COP"
    },
    cr: {
      document_type: "CUIT",
      IsoCode3: "CRI",
      currency: "CRC"
    },
    do: {
      document_type: "",
      IsoCode3: "DOM",
      currency: "DOP"
    },
    ec:{
      document_type: "CE",
      IsoCode3: "ECU",
      currency: "USD"
    },
    eea:{
      document_type: "ID",
      IsoCode3: "EEA",
      currency: "EUR"
    },
    mx: {
      document_type: "RFC",
      IsoCode3: "MEX",
      currency: "MXN"
    },
    pa: {
      document_type: "RUC",
      IsoCode3: "PAN",
      currency: "USD"
    },
    py: {
      document_type: "CUIT",
      IsoCode3: "PRY",
      currency: "PYG"
    },
    pe: {
      document_type: "CUIT",
      IsoCode3: "PER",
      currency: "PEN"
    },
    uy:{
      document_type: "CI",
      IsoCode3: "URY",
      currency: "UYU"
    },
    gt:{
      document_type: "ID",
      IsoCode3: "GTM",
      currency: "GTQ"
    },
    hn:{
      document_type: "ID",
      IsoCode3: "HND",
      currency: "HNL"
    },
    sv: {
      document_type: "ID",
      IsoCode3: "SLV",
      currency: "USD"
    },
    ca: {
      document_type: "Passport",
      IsoCode3: "CAN",
      currency: "CAD"
    },
    ot:{
      document_type: "ID",
      IsoCode3: "OTH",
      currency: "USD"
    },
    au: {
      document_type: "TFN",  // Tax File Number
      IsoCode3: "AUS",
      currency: "AUD"
    },
    bd: {
      document_type: "NID",  // National ID
      IsoCode3: "BGD",
      currency: "BDT"
    },
    cg: {
      document_type: "CN",   // Carte Nationale
      IsoCode3: "COG",
      currency: "CDF"
    },
    gh: {
      document_type: "GhanaCard",
      IsoCode3: "GHA",
      currency: "GHS"
    },
    in: {
      document_type: "Aadhaar",
      IsoCode3: "IND",
      currency: "INR"
    },
    id: {
      document_type: "KTP",  // Kartu Tanda Penduduk
      IsoCode3: "IDN",
      currency: "IDR"
    },
    jp: {
      document_type: "MyNumber",
      IsoCode3: "JPN",
      currency: "JPY"
    },
    ke: {
      document_type: "ID",
      IsoCode3: "KEN",
      currency: "KES"
    },
    kr: {
      document_type: "RRN",  // Resident Registration Number
      IsoCode3: "KOR",
      currency: "KRW"
    },
    my: {
      document_type: "MyKad",
      IsoCode3: "MYS",
      currency: "MYR"
    },
    mw: {
      document_type: "NID",
      IsoCode3: "MWI",
      currency: "MWK"
    },
    ng: {
      document_type: "NIN",  // National Identity Number
      IsoCode3: "NGA",
      currency: "NGN"
    },
    pk: {
      document_type: "CNIC", // Computerized National Identity Card
      IsoCode3: "PAK",
      currency: "PKR"
    },
    rw: {
      document_type: "NID",
      IsoCode3: "RWA",
      currency: "RWF"
    },
    sg: {
      document_type: "NRIC", // National Registration Identity Card
      IsoCode3: "SGP",
      currency: "SGD"
    },
    th: {
      document_type: "ID",
      IsoCode3: "THA",
      currency: "THB"
    },
    tr: {
      document_type: "TC",   // Turkish Citizenship ID
      IsoCode3: "TUR",
      currency: "TRY"
    },
    tw: {
      document_type: "NID",
      IsoCode3: "TWN",
      currency: "TWD"
    },
    tz: {
      document_type: "NID",
      IsoCode3: "TZA",
      currency: "TZS"
    },
    ug: {
      document_type: "NIN",
      IsoCode3: "UGA",
      currency: "UGX"
    },
    vn: {
      document_type: "CMND/CCCD", // Citizen Identity Card
      IsoCode3: "VNM",
      currency: "VND"
    },
    cm: {
      document_type: "NID",
      IsoCode3: "CMR",
      currency: "XAF"
    },
    bj: {
      document_type: "NID",
      IsoCode3: "BEN",
      currency: "XOF"
    },
    ci: {
      document_type: "NID",
      IsoCode3: "CIV",
      currency: "XOF"
    },
    sn: {
      document_type: "NID",
      IsoCode3: "SEN",
      currency: "XOF"
    },
    bf: {
      document_type: "NID",
      IsoCode3: "BFA",
      currency: "XOF"
    },
    tg: {
      document_type: "NID",
      IsoCode3: "TGO",
      currency: "XOF"
    },
    zm: {
      document_type: "NRC",  // National Registration Card
      IsoCode3: "ZMB",
      currency: "ZMW"
    },
    cn:{
      document_type: "RIC",  // National Registration Card
      IsoCode3: "CHN",
      currency: "CNY"
    },
    ph:{
      document_type: "PSN",  // National Registration Card
      IsoCode3: "PHL",
      currency: "PHP"
    },
    ve:{
      document_type: "CI", 
      IsoCode3: "VEN",
      currency: "VES"
    },
    us: {
      document_type: "SSN",  // Social Security Number
      IsoCode3: "USA",
      currency: "USD"
    },
    gb: {
        document_type: "Passport",
        IsoCode3: "GBR",
        currency: "GBP"
    }    
  }
  
  export default LpData;
  